import styled from "styled-components";
import { config, partnerConfigs } from "../../core/config";
import { Container } from "../../core/styles";
import Title from "../../components/Title";
import mastercard from "../../images/card/mastercard.png";
import visa from "../../images/card/visa.png";
import mir from "../../images/card/mir.png";

import qrcode from '../../images/apps/qrcode.svg';
import googlePlay from '../../images/apps/googleplay.svg';
import appStore from '../../images/apps/appstore.svg';
import ruStore from '../../images/apps/rustore.svg';

import { useSelector } from "react-redux";
import { formatPhoneNumber } from "../../core/utils";
import ContactIcons from "../../components/ContactIcons";

const Footer = () => {
    const { appSettings } = useSelector((state) => state.common);
    const { currentPartner } = useSelector((state) => state.partner);
    const { currentKitchen } = useSelector((state) => state.kitchens);

    const links = [
        { name: 'Стоимость доставки', url: '/about' },
        { name: 'Зона доставки', url: '/delivery' },
        { name: 'Кухням', url: '/kitchens' },
        { name: 'Организациям', url: '/organizations' },
        { name: 'Курьерам', url: '/courier' },
    ]

    const contacts = appSettings?.contacts?.filter(contact => !contact.link.includes('wa')) || [];
    const phoneContact = contacts.find(c => c.link && c.link.startsWith('tel'));

    const phoneHref = phoneContact?.link || 'tel:88002006924';
    const phoneNumberForFormat = phoneContact ? phoneContact.link.replace(/^tel:\+?/, '').replace(/^tel:/, '') : '88002006924';
    const phoneDisplay = formatPhoneNumber(phoneNumberForFormat);

    if (currentPartner && partnerConfigs[currentPartner]) {
        return (
            <PartnerWrapper>
                <Container>
                    <PartnerSection>
                        <FirstPartnerItem>
                            <PartnerTitle>{partnerConfigs[currentPartner].name || currentKitchen?.name}</PartnerTitle>
                            <PartnerCopyright>&copy; {new Date().getFullYear()} Все права защищены</PartnerCopyright>
                        </FirstPartnerItem>

                        <PartnerGrid>
                            {partnerConfigs[currentPartner].address &&
                                <PartnerItem style={{ flex: 2 }}>
                                    <PartnerLabel>Адрес:</PartnerLabel>
                                    <PartnerText>{partnerConfigs[currentPartner].address}</PartnerText>
                                </PartnerItem>
                            }

                            {partnerConfigs[currentPartner].contactPhones?.length > 0 &&
                                <PartnerItem>
                                    <PartnerLabel>Телефон{partnerConfigs[currentPartner].contactPhones.length > 1 && 'ы'}:</PartnerLabel>
                                    <PartnerPhones>
                                        {partnerConfigs[currentPartner].contactPhones.map((phone, idx) => (
                                            <PartnerPhone key={idx} href={`tel:${phone}`}>{formatPhoneNumber(phone)}</PartnerPhone>
                                        ))}
                                    </PartnerPhones>
                                </PartnerItem>
                            }

                            {partnerConfigs[currentPartner].openingHours &&
                                <PartnerItem>
                                    <PartnerLabel>Режим работы:</PartnerLabel>
                                    <PartnerText>{partnerConfigs[currentPartner].openingHours}</PartnerText>
                                </PartnerItem>
                            }

                            {partnerConfigs[currentPartner].socialLinks && Object.values(partnerConfigs[currentPartner].socialLinks).some(value => value) &&
                                <PartnerItem>
                                    <PartnerLabel>Мы в соцсетях:</PartnerLabel>
                                    {Object.entries(partnerConfigs[currentPartner].socialLinks).map(([key, value]) => 
                                        value && (
                                            <PartnerLink key={key} href={value} target="_blank" rel="noopener noreferrer">
                                                {key === 'vk' ? 'ВКонтакте' : 
                                                key === 'tg' ? 'Telegram' : 
                                                key === 'ws' ? 'WhatsApp' : 
                                                key}
                                            </PartnerLink>
                                        )
                                    )}
                                </PartnerItem>
                            }
                        </PartnerGrid>
                    </PartnerSection>
                </Container>
            </PartnerWrapper>
        )
    } else if (currentPartner) {
        return (
            <PartnerWrapper>
                <Container>
                    <PartnerSection>
                        <PartnerTitle>{currentKitchen?.name}</PartnerTitle>
                        <PartnerCopyright>&copy; {new Date().getFullYear()} Все права защищены</PartnerCopyright>
                    </PartnerSection>
                </Container>
            </PartnerWrapper>
        )
    } else {
        return (
            <>
            {/* <Subscribe/> */}
                <Wrapper>
                    <Container>
                        <Grid>
                            <NameBlock>
                                <Title>Сытый</Title>
                                <p>Сервис доставки еды 2018-{new Date().getFullYear()}</p>
                            </NameBlock>

                            <LinksBlock>
                                {links.map((link, idx) => (
                                    <a key={idx} href={link.url} target="_blank" rel="noopener noreferrer">{link.name}</a>
                                ))}
                            </LinksBlock>

                            <AppsBlock>
                                <Title>Скачайте приложение</Title>
                                <AppsGrid>
                                    <AppQR>
                                        <img width="132" height="132" src={qrcode} alt="qrcode"/>
                                    </AppQR>
                                    <AppLink href={config.appLinks.appstore}>
                                        <img width="160" height="60" src={appStore} alt="appStore"/>
                                    </AppLink>
                                    <AppLink href={config.appLinks.playmarket}>
                                        <img width="160" height="60" src={googlePlay} alt="googlePlay"/> 
                                    </AppLink>
                                    <AppLink href={config.appLinks.rustore}>
                                        <img width="160" height="60" src={ruStore} alt="ruStore"/>
                                    </AppLink>
                                </AppsGrid>
                            </AppsBlock>

                            <InfoBlock>
                                <Info>
                                    <Title style={{whiteSpace: 'nowrap'}}>
                                        <a href={phoneHref} style={{ textDecoration: 'none', color: 'inherit' }}>{phoneDisplay}</a>
                                    </Title>
                                    <p>звонок бесплатный</p>
                                    <PaymentIcons>
                                        <img width="56" height="16" src={mir} alt="МИР"/>
                                        <img width="49" height="16" src={visa} alt="Visa"/>
                                        <img width="25" height="20" src={mastercard} alt="MasterCard"/>
                                    </PaymentIcons>
                                </Info>
                                <SocialLinks>
                                    <ContactIcons showTel={false} sort='desc'/>
                                </SocialLinks>
                            </InfoBlock>
                        </Grid>
                    </Container>
                </Wrapper>

                <Container>
                    <FooterNote>
                        © Сытый - Сервис доставки еды 2018-{new Date().getFullYear()}
                    </FooterNote>
                </Container>
            </>
        )
    }
};

export default Footer;

const PartnerWrapper = styled.footer`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 32px 16px;
    background: #222;
    color: #fff;
    font-size: 14px;
`;

const PartnerSection = styled.div`
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 32px 64px;
    @media (max-width: 768px) {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 20px;
        text-align: center;
    }
`;

const PartnerGrid = styled.div`
    flex: 1;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 16px 32px;

    @media (max-width: 768px) {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 20px;
        text-align: center;
    }
`;

const PartnerItem = styled.div`
    flex: 0 1 auto;
    min-width: 250px;
    max-width: 300px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    @media (max-width: 1024px) {
        flex: 1 1 auto;
        max-width: 100%;
        align-items: center;
    }
`;

const FirstPartnerItem = styled(PartnerItem)`
    flex: 0 1 300px;
    @media (max-width: 1024px) {
        flex: 1 1 auto;
        max-width: fit-content;
    }
`;

const PartnerTitle = styled.h3`
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #fff;
    margin-bottom: 4px;
`;

const PartnerCopyright = styled.p`
    margin: 0;
    font-size: 12px;
    color: #ccc;
    white-space: nowrap;
`;

const PartnerLabel = styled.span`
    font-weight: 600;
    color: #fff;
    font-size: 14px;
`;

const PartnerText = styled.span`
    color: #ccc;
    font-size: 14px;
    line-height: 1.4;
    white-space: pre-wrap;
    word-wrap: break-word;
    overflow-wrap: break-word;
`;

const PartnerPhones = styled.div`
    display: flex;
    gap: 16px;
    flex-wrap: wrap;
`;

const PartnerPhone = styled.a`
    color: #4CAF50;
    text-decoration: none;
    font-size: 14px;
    transition: opacity 0.2s ease;
    
    &:hover {
        opacity: 0.8;
        text-decoration: underline;
    }
`;

const PartnerLink = styled.a`
    color: #2196F3;
    text-decoration: none;
    font-size: 14px;
    transition: opacity 0.2s ease;
    
    &:hover {
        opacity: 0.8;
        text-decoration: underline;
    }
`;

const Wrapper = styled.div`
    flex: 0 1 auto;
    padding: 50px 0;
    background: #EDEDED;
    border: 1px solid #E0E0E0;
    @media(max-width: 798px) {
        padding: 24px 0;
    }
`;

const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 50px;
    flex-wrap: wrap;
    @media (max-width: 1200px) {
        grid-template-columns: repeat(1, 1fr);
    }
    @media(max-width: 798px) {
        gap: 24px;
    }
`;

const NameBlock = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    @media(max-width: 798px) {
        display: none;
    }
`;

const LinksBlock = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(2, 1fr);
    grid-auto-flow: column;
    gap: 32px 48px;
    flex: 1;
    a {
        color: #7c7c7c;
        text-decoration: none;
        white-space: nowrap;
    }
    @media(max-width: 798px) {
        grid-template-columns: repeat(1, 1fr);
        grid-template-rows: repeat(5, 1fr);
        justify-items: center;
        gap: 16px;
    }
`;

const AppsBlock = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    @media(max-width: 798px) {
        align-items: center;
    }
`;
const AppsGrid= styled.div`
    display: grid;
    grid-template-columns: 132px 160px 160px;
    grid-template-rows: 1fr 1fr;
    align-items: center;
    gap: 12px;
    max-width: 470px;
    @media(max-width: 798px) {
        grid-template-columns: repeat(1, 1fr);
        grid-template-rows: repeat(4, 1fr);
        justify-items: center;
    }
`;
const AppQR = styled.div`
    grid-row: span 2; /* QR-код занимает 2 строки */
    width: 132px;
    height: 132px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 16px;
    overflow: hidden;
`;
const AppLink = styled.a`
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 160px;
    border-radius: 16px;
    overflow: hidden;
`;

const InfoBlock = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 32px;
    flex: 1;
    
    @media(max-width: 798px) {
        grid-template-columns: repeat(1, 1fr);
        justify-items: center;
    }
`;

const Info = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    @media(max-width: 798px) {
        align-items: center;
    }
`;

const PaymentIcons = styled.div`
    display: flex;
    gap: 8px;
`;

const SocialLinks = styled.div`
    display: flex;
    gap: 16px;
`;

const IconButton = styled.a`
    position: relative;
    min-width: 60px;
    height: 60px;
    border-radius: 18px;
    background-color: ${(props) => props.bgColor || '#EA394B'};
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    font-size: 24px;
    color: #ffffff !important;
    text-decoration: none;
    transition: transform 0.3s ease, opacity 0.3s ease;
`;

const FooterNote = styled.div`
    display: none;
    @media(max-width: 798px) {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 16px 16px 24px;
    }
`;
